import { Tooltip } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components/macro';
import Colors from '../internal-components/Colors';
import { SimpleFlexContainer } from './layouts/ng-layouts/Containers';

const Container = styled(SimpleFlexContainer)`
  height: 7px;

  div:first-child {
    margin-left: 0;
  }
  div:last-child {
    margin-right: 0;
  }
`;

const Block = styled.div`
  ${({ $color }) => $color && `background: ${$color};`}
  flex: 1;
  border-radius: 10px;
  margin: 0.1rem;
  transition: 0.5s;
`;

const strengthMapping = {
  0: { color: Colors.OT_RED, label: 'Weak' },
  1: { color: '#FFC300', label: 'Moderate' },
  2: { color: Colors.PRIMARY, label: 'Strong' }
};

const StrengthMeter = ({ value = 0, mapping = strengthMapping }) => {
  return (
    <Tooltip arrow title={(mapping[value] || { label: '' }).label}>
      <Container $row>
        {Object.entries(mapping).map(([v, color]) => {
          return (
            <Block
              key={v}
              $color={
                v <= value
                  ? (mapping[value] || { color: Colors.BORDER_GREY }).color
                  : Colors.BORDER_GREY
              }
            />
          );
        })}
      </Container>
    </Tooltip>
  );
};

export default StrengthMeter;
